import Accordion from '../components/Accordion';

export default class Accordions {
	constructor() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			this.init(e.target);
		});
	}

	init(element) {
		const accordions = element.querySelectorAll('[data-accordion]');

		if (!accordions.length) {
			return;
		}

		accordions.forEach((accordion) => {
			new Accordion(accordion);
		});
	}
}
